import api from "../../api";
import {promptData, successPromptData} from "../../util/MessageTools";
import {dateStr2Timestamp, formatDate} from '../../util/TimeTransition'

export default {
  name: "timeManage",
  data() {
    return {
      register_enter_oneContribute_startTime: null,
      register_enter_oneContribute_endTime: null,

      oneContributeCheck_startTime: null,
      oneContributeCheck_endTime: null,

      train_startTime: null,
      train_endTime: null,

      twoContribute_startTime: null,
      twoContribute_endTime: null,

      twoContributeCheck_startTime: null,
      twoContributeCheck_endTime: null,

      publicity_startTime: null,
      publicity_endTime: null,

      threeContribute_startTime: null,
      threeContribute_endTime: null,

      finalVersion_startTime: null,
      finalVersion_endTime: null,

      data: [],//用数组向后台传输数据
    }
  },
  methods: {
    /**
     * 保存时间
     */
    saveTime() {
      this.data = []
      let obj1 = {}
      obj1.id = 1
      obj1.startTime = new Date(this.register_enter_oneContribute_startTime)
      obj1.endTime = new Date(this.register_enter_oneContribute_endTime)

      this.data.push(obj1)

      let obj2 = {}
      obj2.id = 2
      obj2.startTime = new Date(this.oneContributeCheck_startTime)
      obj2.endTime = new Date(this.oneContributeCheck_endTime)
      this.data.push(obj2)

      let obj3 = {}
      obj3.id = 3
      obj3.startTime = new Date(this.train_startTime)
      obj3.endTime = new Date(this.train_endTime)
      this.data.push(obj3)

      let obj4 = {}
      obj4.id = 4
      obj4.startTime = new Date(this.twoContribute_startTime)
      obj4.endTime = new Date(this.twoContribute_endTime)
      this.data.push(obj4)

      let obj5 = {}
      obj5.id = 5
      obj5.startTime = new Date(this.twoContributeCheck_startTime)
      obj5.endTime = new Date(this.twoContributeCheck_endTime)
      this.data.push(obj5)

      let obj6 = {}
      obj6.id = 6
      obj6.startTime = new Date(this.publicity_startTime)
      obj6.endTime = new Date(this.publicity_endTime)
      this.data.push(obj6)

      let obj7 = {}
      obj7.id = 7
      obj7.startTime = new Date(this.threeContribute_startTime)
      obj7.endTime = new Date(this.threeContribute_endTime)
      this.data.push(obj7)

      let obj8 = {}
      obj8.id = 8
      obj8.startTime = new Date(this.finalVersion_startTime)
      obj8.endTime = new Date(this.finalVersion_endTime)
      this.data.push(obj8)
      let vue = this

      api.timeManage.updateAll(this.data).then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          successPromptData("修改时间成功!", vue)
        }
      })
    }

  },

  created() {
    let vue = this
    api.timeManage.getAllTime().then(function (response) {
      if (response == null) {
        return null
      }
      if (response.data.code === "0") {
        let result = response.data.result

        vue.register_enter_oneContribute_startTime = result[0].startTime
        vue.register_enter_oneContribute_endTime = result[0].endTime

        vue.oneContributeCheck_startTime = result[1].startTime
        vue.oneContributeCheck_endTime = result[1].endTime

        vue.train_startTime = result[2].startTime
        vue.train_endTime = result[2].endTime

        vue.twoContribute_startTime = result[3].startTime
        vue.twoContribute_endTime = result[3].endTime

        vue.twoContributeCheck_startTime = result[4].startTime
        vue.twoContributeCheck_endTime = result[4].endTime

        vue.publicity_startTime = result[5].startTime
        vue.publicity_endTime = result[5].endTime

        vue.threeContribute_startTime = result[6].startTime
        vue.threeContribute_endTime = result[6].endTime

        vue.finalVersion_startTime = result[7].startTime
        vue.finalVersion_endTime = result[7].endTime

      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/Admin/TimeManage.js